export default __webpack_public_path__ + "static/media/80_desktop.3af4dbf0.jpg";